import { cn } from "@/lib/utils";
import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";
import { PaginationWithDots } from "@/components/data-table/Pagination";
import { PieChartProps } from "@/modules/finance/helper/types/pie-chart-props.type";

export const PieChartComponent = ({ className, chartHeight = 155, charts }: PieChartProps) => {
  const [step, setStep] = useState<number>(1);

  useEffect(() => {
    if (charts.length === 0) {
      // No charts to display; reset step to initial value.
      setStep(1);
      return;
    }

    setStep((prevStep) => {
      if (prevStep < 1) {
        return 1;
      }
      if (prevStep > charts.length) {
        return charts.length;
      }
      return prevStep;
    });
  }, [charts.length]);

  return (
    <div
      className={cn("flex-1 rounded-2xl border border-icon pt-[15px] pb-[14.94px] pl-[26px] pr-7 bg-white", className)}
    >
      <div className="flex">
        {charts.length > 0 && (
          <>
            <span className="font-black text-xs leading-[15px] text-chart-title h-[15px] mt-1 flex-none">
              {charts[step - 1].title}
            </span>
            <div className="flex flex-col ml-3 w-full">
              <ReactECharts option={charts[step - 1].chartOptions} style={{ height: chartHeight }} />
              {charts.length > 1 && (
                <PaginationWithDots
                  totalPage={charts.length}
                  currentPage={step}
                  onChangePage={setStep}
                  type="dot"
                  className="h-[8.5px] mt-[12.94px] ml-[47.5px]"
                  showControl={false}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
